// --------------------------------------------------------------
// Created On: 2022-07-27
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./RentOutAssetListRow.module.scss";

// A single rented out asset in a list of rented out assets.
export default function RentOutAssetListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="rentout-list-row">
      <span>Asset &apos;</span>

      <b>{props.name}</b>

      <span>&apos; is rented to &apos;</span>

      <b>{props.renteeCompanyName}</b>

      <span>&apos;</span>

      {props.isPendingApproval && (
        <span data-test="pending-rental-marker" className={styles.tag}>
          Pending
        </span>
      )}
    </div>
  );
}

interface Props {
  assetId: number;
  name: string;
  renteeCompanyName: string;
  isPendingApproval: boolean;
}
